import React from "react";
import PropTypes from "prop-types";

import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import { EXPANDABLE_LIST_ITEM_CLASS } from "../../../constants/ui";

const expandable = open => {
  switch (open) {
    case true:
      return <ExpandLess />;
    case false:
      return <ExpandMore />;
    default:
      return null;
  }
};

const ExpandableButtonListItem = ({ title, open, icon, onClickHandler }) => {
  return (
    <ListItem className={EXPANDABLE_LIST_ITEM_CLASS} disablePadding>
      <ListItemButton onClick={onClickHandler}>
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        <ListItemText primary={title} sx={theme => ({ pl: theme.spacing(2) })} />
        {expandable(open)}
      </ListItemButton>
    </ListItem>
  );
};

ExpandableButtonListItem.defaultProps = {
  icon: undefined,
  open: undefined,
};

ExpandableButtonListItem.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
  icon: PropTypes.object,
  onClickHandler: PropTypes.func.isRequired,
};

export default ExpandableButtonListItem;
